import React, { useRef, useEffect, useState } from 'react';
import './Card.css';
import CountUp from 'react-countup';

function Card(props) {
  return (
    <>
    <div className='serv-card rounded'>
        <div>
            {props.icon}
        </div>
        <div>
        <h4>{props.title}</h4>
        <p>{props.info}</p>
        <p>{props.plus1}</p>
        <p>{props.plus2}</p>
        <p>{props.plus3}</p>
        <p>{props.plus4}</p>
        </div>
    </div>
    </>
  )
}

function Cards(props) {
   
  return (
    <>
    <div className='cards rounded'>
        <div>
            {props.icon}
        </div>
        <div>
        <h4>{props.title}</h4>
        <p>{props.info}</p>
        </div>
    </div>
    </>
  )
}

function CardNoBorder(props) {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // تحقق إذا كان العنصر مرئيًا
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 } // 50% من القسم يجب أن يظهر ليتم اعتباره مرئيًا
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <>
      <div className='work-card' ref={sectionRef}>
      <div>
          {props.icon}
        </div>
        {isVisible && <h4><CountUp start={0} end={parseInt(props.title, 10)} duration={4} /></h4>}
        <p>{props.info}</p>
      </div>
    </>
  );
}

export default Card;
export {CardNoBorder};
export {Cards};